import { NgModule } from '@angular/core';
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material-module';
import {MatIconModule} from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { SurveyApiService } from './survey-api.service';
import { SurveyMainComponent } from './survey-main.component';
import { HeaderComponent } from '../survey-main/header/header.component';
import { ActivitySummaryComponent } from '../survey-main/activity-summary/activity-summary.component';
import { SurveyFormComponent } from '../survey-main/survey-form/survey-form.component';
import { FooterComponent } from '../survey-main/footer/footer.component';



@NgModule({
    declarations: [SurveyMainComponent, HeaderComponent, ActivitySummaryComponent, SurveyFormComponent, FooterComponent],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        RouterModule,
        MaterialModule,
        MatIconModule,
        SharedModule,
    ],
    exports: [SurveyMainComponent],
    providers: [SurveyApiService]
})
export class SurveyModule { }
